import React from 'react';

import { RouteContext } from 'src/context';
import ContractSettingsPage from 'src/legacy/components/Contracts/ContractSettingsPage';
import FileSettingsPage from 'src/legacy/components/Files/FileSettingsPage';
import SetupAppPageRouter from 'src/legacy/components/Settings/AppSetupPage/SetupApp/SetupAppPage';
import { BankingDefaultsSettings } from 'src/legacy/components/Settings/BankingPage/BankingDefaultsSettings';
import MessagingPage from 'src/legacy/components/Settings/MessagingPage';

interface AppSettingsModalContentProps {
  moduleType: string;
  moduleId: string;
  appId?: string;
}

export const AppSettingsModalContent = ({
  moduleType,
  moduleId,
  appId,
}: AppSettingsModalContentProps) => {
  const routeContext = React.useContext(RouteContext);

  const syntheticContext = React.useMemo(() => {
    const { preset: _preset, ...restQuery } = routeContext.query;
    return {
      ...routeContext,
      query: {
        ...restQuery,
        moduleId,
        moduleType,
        appId: appId ?? '',
      },
    };
  }, [routeContext, moduleId, moduleType, appId]);

  const renderContent = () => {
    if (moduleType === 'module') {
      if (moduleId === 'files') return <FileSettingsPage />;
      if (moduleId === 'messages') return <MessagingPage />;
      if (moduleId === 'payments') return <BankingDefaultsSettings />;
      if (moduleId === 'contracts') return <ContractSettingsPage />;
    }
    return <SetupAppPageRouter />;
  };

  return (
    <RouteContext.Provider value={syntheticContext}>
      {renderContent()}
    </RouteContext.Provider>
  );
};
